import { Box, Text } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

const MotionText = motion(Text);
const MotionBox = motion(Box);

export default function TextAnimationDisplay({
  text,
  textStyle,
  bgColor = 'transparent',
}) {
  return (
    <Box
      position="absolute"
      width="100%"
      height="100%"
      inset="0"
      zIndex="100"
      pointerEvents="none"
    >
      <AnimatePresence>
        {text && (
          <MotionBox
            key={`${text}-bg`}
            position="absolute"
            inset="0"
            background={bgColor}
            borderRadius="inherit"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          />
        )}
        {text && (
          <MotionText
            key={text}
            position="absolute"
            inset="0"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="2xl"
            fontWeight="bold"
            pointerEvents="none"
            {...textStyle}
            initial={{ opacity: 0, scale: 0.4 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 1.2 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            {text}
          </MotionText>
        )}
      </AnimatePresence>
    </Box>
  );
}
